import TOLGEE_GLOBALS from 'utils/tolgeeGlobals'

import type { ISearchTerritoryCompareGroupConfig } from './get-search-territory-compare-groups.types'

export const OWNED_TOPIC_TERRITORY_TYPE = 'saved_search'

export const SEARCH_TERRITORY_COMPARE_GROUPS: readonly ISearchTerritoryCompareGroupConfig[] = [
  { label: TOLGEE_GLOBALS.themes, types: ['theme'] },
  { label: TOLGEE_GLOBALS.segments, types: ['segment'] },
  { label: TOLGEE_GLOBALS.subjects, types: ['subject'] },
  { label: TOLGEE_GLOBALS.entities, types: ['entity', 'entity_query'] },
]
